import { FC, lazy, Suspense } from 'react';

import Cover from 'src/components/common/Cover';
import 'src/components/pages/ToursPage/styles.scss';

const ToursPageContent = lazy(() => import('src/components/pages/ToursPage/ToursPageContent'));

const HomePage: FC = () => {
  return (
    <div className="tours-page-container">
      <Cover />
      <Suspense fallback={null}>
        <ToursPageContent headerName="mostPopular" fromAiSuggestions={false} />
      </Suspense>
    </div>
  );
};

export default HomePage;
